import { createFileRoute } from "@tanstack/react-router";
import { CreditCard } from "lucide-react";
import { useAuth } from "../stores/auth";
import { useActiveCompany } from "../stores/active-company";
import { SectionTitle } from "../components/admin/shared";
import { BillingHealthPanel, BillingSection, CompanyBillingCard } from "../components/admin/billing";

export const Route = createFileRoute("/admin/billing")({
  component: AdminBillingPage,
});

function AdminBillingPage() {
  const user = useAuth((s) => s.user);
  const activeCompanyId = useActiveCompany((s) => s.activeCompanyId);
  if (!user) return null;
  if (user.role === "global_admin") {
    return (
      <div className="space-y-8">
        <BillingHealthPanel />
        {activeCompanyId ? (
          <BillingSection companyId={activeCompanyId} />
        ) : (
          <section className="space-y-4">
            <SectionTitle icon={<CreditCard size={18} />} title="EEX billing" />
            <div className="text-sm text-muted">Select a company to manage its billing.</div>
          </section>
        )}
      </div>
    );
  }
  return <CompanyBillingCard />;
}
